export default function RejectionEmail({
  fullName,
  observations,
}: {
  fullName: string;
  observations?: string;
}) {
  return `
  <div style="font-family: Arial, sans-serif; background-color: #f9f9f9; padding: 40px 0;">
    <div style="max-width: 600px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 6px rgba(0,0,0,0.1);">
      <div style="background-color: #E95B0C; padding: 20px; text-align: center;">
        <h1 style="color: #ffffff; margin: 0; font-size: 22px;">Feria de Emprendedores 2025 UAT-UAMVH</h1>
      </div>

      <div style="padding: 30px;">
        <p style="font-size: 16px; color: #333;">Hola <strong>${fullName}</strong>,</p>

        <p style="font-size: 15px; color: #333; line-height: 1.6;">
          Agradecemos tu interés en participar como expositor en la <strong>Feria de Emprendedores 2025 UAT-UAMVH</strong>.
          Después de revisar cuidadosamente tu solicitud, lamentamos informarte que en esta ocasión
          <strong>no ha sido aprobada</strong>.
        </p>

        ${
          observations
            ? `
        <div style="background-color: #fff6f0; border-left: 4px solid #E95B0C; padding: 16px; margin: 24px 0; border-radius: 6px;">
          <h3 style="margin: 0 0 10px; color: #E95B0C; font-size: 16px;">Observaciones del comité:</h3>
          <p style="margin: 0; font-size: 15px; color: #444; line-height: 1.6;">
            ${observations}
          </p>
        </div>`
            : `
        <p style="font-size: 15px; color: #333; line-height: 1.6; margin: 24px 0;">
          No se especificaron observaciones adicionales en esta ocasión.
        </p>`
        }

        <p style="font-size: 15px; color: #333; line-height: 1.6;">
          Te invitamos a mantenerte atento a futuras convocatorias. Valoramos tu esfuerzo y entusiasmo,
          y esperamos poder contar contigo en próximos eventos.
        </p>

        <div style="text-align: center; margin-top: 30px;">
          <a href="https://feriadeemprendedoresuat.site/"
             style="background-color: #E95B0C; color: white; text-decoration: none; padding: 12px 28px; border-radius: 8px; font-weight: bold;">
            Visitar sitio web
          </a>
        </div>

        <p style="font-size: 13px; color: #777; margin-top: 40px; text-align: center;">
          Atentamente,<br/>
          <strong>Comité Organizador - Feria de Emprendedores 2025 UAT-UAMVH</strong><br/>
          Universidad Autónoma de Tamaulipas
        </p>
      </div>
    </div>
  </div>`;
}
